var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.5 4.5v1.815c0 1.185-.75 1.935-1.935 1.935H12V3.008c0-.833.682-1.508 1.515-1.508a3.015 3.015 0 0 1 2.107.877c.54.548.878 1.298.878 2.123Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1.5 5.25v10.5c0 .622.705.975 1.2.6l1.282-.96c.3-.225.72-.195.99.075l1.245 1.253a.756.756 0 0 0 1.066 0l1.26-1.26a.743.743 0 0 1 .975-.068l1.282.96a.752.752 0 0 0 1.2-.6V3c0-.825.675-1.5 1.5-1.5h-9c-2.25 0-3 1.342-3 3v.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m4.703 10.298 4.095-4.095",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.945 10.125h.007M4.644 6.375h.007",
    opacity: 0.4
  })));
};
export default SvgWarningIcon;